module.exports = __webpack_public_path__ + "static/media/cooperation2.623c4436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/cooperation2.jpg
// module id = 209
// module chunks = 6